import React from 'react';
import { useIntl } from 'react-intl';

export default function withIntl(Component) {
	function ComponentWithIntl(props) {
		const intl = useIntl();
		return <Component {...props} intl={intl} />;
	}

	return ComponentWithIntl;
}
